import React, { FC } from "react";

type IProps = {
  isLikes?: boolean;
};

const Like: FC<IProps> = ({ isLikes }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill={isLikes ? "#FD8533" : "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.81596 5.77401L5.42596 9.20001C5.37018 9.25625 5.30382 9.30088 5.23071 9.33134C5.15759 9.36181 5.07917 9.37749 4.99996 9.37749C4.92076 9.37749 4.84233 9.36181 4.76922 9.33134C4.6961 9.30088 4.62974 9.25625 4.57396 9.20001L1.18396 5.77401C0.621549 5.21143 0.305603 4.4485 0.305603 3.65301C0.305603 2.85752 0.621549 2.09459 1.18396 1.53201C1.67886 1.03716 2.3312 0.730904 3.02807 0.666258C3.72494 0.601611 4.42248 0.782639 4.99996 1.17801C5.61686 0.75663 6.36878 0.580582 7.10861 0.684309C7.84845 0.788036 8.52297 1.16407 9.0002 1.73885C9.47743 2.31363 9.72304 3.04579 9.68896 3.79208C9.65489 4.53838 9.34359 5.24511 8.81596 5.77401Z"
        fill={isLikes ? "#FD8533" : "#707070"}
      />
    </svg>
  );
};

export default Like;
